/* unplugin-vue-components disabled */import script from "./ExternalPersonPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalPersonPicker.vue?vue&type=script&setup=true&lang=js"

import "./ExternalPersonPicker.vue?vue&type=style&index=0&id=3731edde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3731edde"]])

export default __exports__